import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';

const RestaurantInfo = ({ restaurant }) => {
  const navigate = useNavigate();
  const infoItems = [
    {
      icon: 'Wallet',
      label: 'الحد الأدنى',
      value: `${restaurant?.pricing?.min_order_price} ل.س`
    },
    {
      icon: 'Bike',
      label: 'وقت التوصيل',
      value: restaurant?.timing?.average_delivery_time
        ? `${restaurant.timing.average_delivery_time} دقيقة`
        : 'غير محدد'
    },
    {
      icon: 'MessageCircle',
      label: 'التعليقات',
      value: (() => {
        const avg = restaurant?.rating?.average ?? restaurant?.rating;
        const total =
          restaurant?.rating?.reviews_count ??
          restaurant?.reviews?.total ??
          restaurant?.reviews_count ??
          0;
        const avgPart =
          avg != null && avg !== '' && !Number.isNaN(Number(avg))
            ? `${Number(avg).toFixed(1)} · `
            : '';
        return `${avgPart}${total}`;
      })()
    }
  ];


  return (
    <div className="px-4 font-[cairo] bg-white">

      <div className="flex w-full bg-white border-2 border-[#F2F2F2] rounded-[8px] p-1">

        {infoItems.map((item, index) => {
          const isReviews = item.label === 'التعليقات';

          return (
            <div
              key={index}
              onClick={() => {
                if (isReviews) {
                  navigate(`/market/${restaurant.slug}/reviews`);
                }
              }}
              className={`flex-1 mx-1 bg-white p-1 flex flex-col items-center justify-center
    ${isReviews ? 'border-2 border-[#F93209] rounded-[4px] m-1 cursor-pointer' : 'm-1'}
  `}
            >
              <div className="flex flex-row gap-1 items-center">
                <Icon
                  name={item.icon}
                  size={12}
                  className={`${isReviews ? 'text-[#F93209]' : 'text-gray-500'}`}
                />

                <span className={`text-xs ${isReviews ? 'text-[#F93209]' : 'text-gray-500'}`}>
                  {item.label}
                </span>
              </div>

              <span className="text-sm font-bold mt-1 text-center">
                {item.value}
              </span>
            </div>
          );
        })}

      </div>
    </div>
  );
};

export default RestaurantInfo;